import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import logoEva from "../MainPage/logoEva.png";
import { apiDelete } from "../../api/client";

export default function CancelarReserva() {
  const { id } = useParams();
  const [status, setStatus] = useState("loading"); // "loading" | "success" | "already"

  useEffect(() => {
    apiDelete(`/booking?session=${id}`, { context: "cancelar_reserva" })
      .then(({ data }) => {
        if (data.error) {
          setStatus("already");
        } else {
          setStatus("success");
        }
      })
      .catch(() => {
        setStatus("already");
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={styles.page}>
      <header style={styles.header}>
        <a href="/">
          <img src={logoEva} alt="Peluquería Eva" height={60} />
        </a>
      </header>
      <div style={styles.card}>
        {status === "loading" ? (
          <div style={styles.spinnerContainer}>
            <div className="spinner"></div>
          </div>
        ) : status === "success" ? (
          <>
            <div style={styles.iconCircle("#4CAF50")}>
              <span style={styles.icon}>&#10003;</span>
            </div>
            <h2 style={styles.title}>Reserva cancelada</h2>
            <p style={styles.text}>
              Tu reserva ha sido cancelada correctamente.
            </p>
            <a href="/" style={styles.button}>
              Volver al inicio
            </a>
          </>
        ) : (
          <>
            <div style={styles.iconCircle("#f44336")}>
              <span style={styles.icon}>&#10007;</span>
            </div>
            <h2 style={styles.title}>Reserva ya cancelada</h2>
            <p style={styles.text}>
              Esta reserva ya fue cancelada anteriormente o no existe.
            </p>
            <a href="/" style={styles.button}>
              Volver al inicio
            </a>
          </>
        )}
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#000",
    color: "#fff",
  },
  header: {
    position: "absolute",
    top: 0,
    padding: "2em 0",
    borderBottom: "1px solid rgba(255,255,255,0.1)",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  card: {
    backgroundColor: "#111",
    borderRadius: "12px",
    padding: "2.5em 2em",
    maxWidth: "420px",
    width: "90%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    boxShadow: "0 4px 20px rgba(0,0,0,0.4)",
  },
  iconCircle: (color) => ({
    width: "64px",
    height: "64px",
    borderRadius: "50%",
    backgroundColor: color,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "1em",
  }),
  icon: {
    fontSize: "32px",
    color: "#fff",
    fontWeight: "bold",
  },
  title: {
    fontSize: "1.4rem",
    margin: "0 0 0.5em 0",
    color: "#fff",
  },
  text: {
    fontSize: "1rem",
    color: "#aaa",
    margin: "0 0 1.5em 0",
    lineHeight: "1.5",
  },
  spinnerContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "2em",
  },
  button: {
    display: "inline-block",
    backgroundColor: "#222",
    color: "#fff",
    padding: "12px 24px",
    borderRadius: "6px",
    textDecoration: "none",
    fontSize: "1rem",
    transition: "background-color 0.2s",
    border: "1px solid #333",
  },
};
